import { isIE } from "react-device-detect";
import { IntlProvider } from "react-intl";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Head from "next/head";
import Script from "next/script";
import * as gtag from "../lib/gtag";
import BrowserNotSupported from "../components/BrowserNotSupported";

// Style
import "swiper/css/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const flattenMessages = (nestedMessages, prefix = "") => {
	if (nestedMessages === null) {
		return {};
	}
	return Object.keys(nestedMessages).reduce((messages, key) => {
		const value = nestedMessages[key];
		const prefixedKey = prefix ? `${prefix}.${key}` : key;

		if (typeof value === "string") {
			Object.assign(messages, { [prefixedKey]: value });
		} else {
			Object.assign(messages, flattenMessages(value, prefixedKey));
		}

		return messages;
	}, {});
};

const languages = {
	pl: require("../locale/pl.json"),
	en: require("../locale/en.json"),
};

export default function App({ Component, pageProps }) {
	const router = useRouter();
	const { locale, defaultLocale } = router;
	const messages = languages[locale];

	const [isIeBrowser, setIsIeBrowser] = useState(false);

	useEffect(() => {
		if (isIE) {
			setIsIeBrowser(true);
		}

		const handleRouteChange = (url) => {
			gtag.pageview(url);
		};

		gtag.pageview(window.location.pathname);

		router.events.on("routeChangeComplete", handleRouteChange);
		return () => {
			router.events.off("routeChangeComplete", handleRouteChange);
		};
	}, [router.events]);

	if (isIeBrowser) {
		return <BrowserNotSupported />;
	}

	return (
		<>
			<Head>
				<meta name="viewport" content="width=device-width, initial-scale=1.0" />
			</Head>

			<Script
				id="gtm-init"
				strategy="beforeInteractive"
				dangerouslySetInnerHTML={{
					__html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gtag.GTM_ID}', {
              page_path: window.location.pathname,
            });
          `,
				}}
			/>

			<Script
				id="gtm-script"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtag.GTM_ID}');
          `,
				}}
			/>

			<IntlProvider
				messages={flattenMessages(messages)}
				locale={locale}
				defaultLocale={defaultLocale}
			>
				<Component {...pageProps} />
			</IntlProvider>
		</>
	);
}
